import { NULL, PROCESSING, SUCCESS } from "../../../utils/valueStaticConstants";
import { StatusType } from "../AdminReportResource";
import {
  DivContainerTable,
  DivContentTable,
  StyledTable,
} from "../AdminReportStyle";
import { RespReport } from "../ReportConvertResponse";
import { SearchGetRegister } from "../SearchGetRegister";

interface Props {
  statusEndpoint: StatusType;
  loadReportExecutor: any;
}

export const ReportTraceability = (props: Props) => {
  const { loadReportExecutor, statusEndpoint } = props;
  const showBackground =
    (loadReportExecutor.status === SUCCESS &&
      statusEndpoint === SUCCESS &&
      loadReportExecutor.data.count === 0) ||
    loadReportExecutor.status === PROCESSING
      ? true
      : statusEndpoint === NULL
      ? true
      : false;
  // TODO: FOR RQ NEXT FOR INTEGRATE WITH BACKEND WHEN ENDPOINT THIS READY
  return (
    <div>
      <DivContainerTable>
        <DivContentTable>
          <StyledTable id="resizeMe">
            <thead>
              <tr>
                <th style={{ resize: "horizontal" }}>{"Nro Volante"}</th>
                <th style={{ resize: "horizontal" }}>
                  {"RUC Agencia Aduanera"}
                </th>
                <th style={{ resize: "horizontal" }}>{"Agente Aduanero"}</th>
                <th style={{ resize: "horizontal" }}>{"Proceso"}</th>
                <th style={{ resize: "horizontal" }}>
                  {"Fecha y hora solicitado"}
                </th>
                <th style={{ resize: "horizontal" }}>{"Estado proceso"}</th>
                <th style={{ resize: "horizontal" }}>{"Rol"}</th>
                <th style={{ resize: "horizontal" }}>{"Perfil"}</th>
                <th style={{ resize: "horizontal" }}>{"Usuario"}</th>
                <th style={{ resize: "horizontal" }}>{"Correo electrónico"}</th>
              </tr>
            </thead>
            {loadReportExecutor.status === SUCCESS &&
              statusEndpoint === SUCCESS && (
                <tbody>
                  {loadReportExecutor.data.data_report.map(
                    (elem: RespReport) => {
                      return (
                        <tr key={elem.id}>
                          <td>{elem.timeslotDate}</td>
                          <td>{elem.timeslotStart}</td>
                          <td>{elem.timeslotEnd}</td>
                          <td>{elem.docksNum}</td>
                          <td>{elem.dockCapacity}</td>
                          <td>{elem.timeslotDate}</td>
                          <td>{elem.timeslotStart}</td>
                          <td>{elem.timeslotEnd}</td>
                          <td>{elem.timeslotDate}</td>
                          <td>{elem.timeslotStart}</td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              )}
          </StyledTable>
        </DivContentTable>
      </DivContainerTable>
      {showBackground && <SearchGetRegister />}
    </div>
  );
};
